<template lang="pug">
.row
  .columns.large-24
    article.content-block
      header
        .title {{t(`app.programs.edit.form_part.label.${form_part.handle}`, {default: form_part.name})}}
      section.content
        div(v-if="isPresent(form_part.description)")
          p.small(v-html="to_br(form_part.description)" v-linkified)
          br
        .concerns
          template(v-for="form_block in form_part.form_blocks")
            concerns-comments-item(v-if="form_block.to_display()" :concern="concern" :form-block="form_block" v-slot:default="{rfb}")
              div
                span.required *
                span.required_text {{t(`helpers.placeholder.form_block.label.${form_block.handle}`, {default: form_block.name})}}
              template(v-for="attr in form_block.attrs")
                concern-attr(
                  :attr="attr"
                  v-model="rfb.entity_attrs[attr]"
                  @change="attrChange(rfb, 0, 'entity_attrs', attr, $event)"
                  :filled="filled"
                )

              article.concern(v-for="cf in form_block.custom_fields")
                concern-custom-attr(
                  :cf="cf",
                  v-model="rfb.custom_attrs[cf.id]"
                  @change="customFieldChanged(rfb, 0, 'custom_attrs',cf.id, $event)"
                  :filled="filled" v-if="filled"
                )
</template>
<script>
import helpers from "../../../../code/base_mixins";
import concernsCommentsItem from './_concerns_comments_item'
import concernAttr from "./_concern_attr.vue"
import concernCustomAttr from "./_concern_custom_attr.vue"
export default{
  name: "FormPartHeaderConcernsComments",
  components: {concernsCommentsItem,concernAttr,concernCustomAttr},
  mixins: [helpers],
  props: ["form_part", "people"], // "people" - to cleanup html
  data(){
    return {
      filled: null,
      entity_id: null,
      concern: {},
    }
  },
  computed: {
    registration(){ return this.state.current_reg },
    editing_provisioned() {return this.registration.id && this.state.current_org.id && this.registration.owner_type === 'TempUser'},
  },
  watch: {
    "registration.person_id"() { this.loadData() },
  },
  created(){
    this.loadData()
  },
  methods: {
    loadData(){
      if (this.registration.new_person_was) return
      if (this.editing_provisioned){ // ONLY FOR PROVISIONED. A hack. In other cases org shouldn't get access to whole person_concern
        this.fill_data(this.registration.person.person_concern)
        return
      }
      this.resetReg()
      this.$store.dispatch("reg_store/person_concern").then(this.fill_data)
    },
    fill_data(concern){
      this.entity_id = concern.id
      this.concern   = concern
      this.filled    = new Date().getTime()
    },
    resetReg(){
      window.$reg ||= {}
      window.$reg.temp_rfb = {}
    },
    customFieldChanged(...args){ //same as in attrChange
      this.attrChange(...args)
      const rfb = args[0]
      rfb.has_changed=true
    },
    attrChange(rfb, idx, group, attr, value){
      if (typeof value === "undefined") return
      const rfb_id = rfb.id
      const fb_id  = rfb.form_block_id
      window.$reg.temp_rfb[fb_id] ||= []
      window.$reg.temp_rfb[fb_id][idx] = {
        id: rfb_id, form_block_id: fb_id,
        _destroy: false,
        name: this.form_part.form_blocks[0].name,
        entity_attrs: {}, custom_attrs: {},
        ...window.$reg.temp_rfb[fb_id][idx]
      }
      // setting to antity_attrs or custom_attrs
      window.$reg.temp_rfb[fb_id][idx][group] = {...window.$reg.temp_rfb[fb_id][idx][group], [attr]: value}
      window.$reg.temp_rfb[fb_id][idx].entity_id = this.entity_id
      this.state.current_reg.doTouch()
    },
  },
}
</script>
